import { BaseApiClient } from '../BaseApiClient'

export class RestTimeApplicationTypeaheads extends BaseApiClient {

  static getUrl (path, base = false) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL + '/nwd'

    return `${baseUrl}/${path}`
  }

  static async personal (q) {
    return this.get('typeahead/personal', {
      params: { q },
      headers: this.getAuthHeaders()
    }).then(response => response.data ? response.data : [])
  }
}
